__turbopack_context__.v({
  "cardInner": "set-module-scss-module__NnuviW__cardInner",
  "cardInnerHorizontal": "set-module-scss-module__NnuviW__cardInnerHorizontal",
  "colAlerts": "set-module-scss-module__NnuviW__colAlerts",
  "colApproved": "set-module-scss-module__NnuviW__colApproved",
  "colExpDate": "set-module-scss-module__NnuviW__colExpDate",
  "colFiles": "set-module-scss-module__NnuviW__colFiles",
  "colLastDate": "set-module-scss-module__NnuviW__colLastDate",
  "colName": "set-module-scss-module__NnuviW__colName",
  "colPermissions": "set-module-scss-module__NnuviW__colPermissions",
  "colSector": "set-module-scss-module__NnuviW__colSector",
  "colSize": "set-module-scss-module__NnuviW__colSize",
  "colSponsor": "set-module-scss-module__NnuviW__colSponsor",
  "colSponsorMySets": "set-module-scss-module__NnuviW__colSponsorMySets",
  "colStatus": "set-module-scss-module__NnuviW__colStatus",
  "colUsers": "set-module-scss-module__NnuviW__colUsers",
  "columnNameMySets": "set-module-scss-module__NnuviW__columnNameMySets",
  "copyIcon": "set-module-scss-module__NnuviW__copyIcon",
  "dataTableContainer": "set-module-scss-module__NnuviW__dataTableContainer",
  "dataroomActions": "set-module-scss-module__NnuviW__dataroomActions",
  "dataroomExpDate": "set-module-scss-module__NnuviW__dataroomExpDate",
  "dataroomExpDateWrp": "set-module-scss-module__NnuviW__dataroomExpDateWrp",
  "dataroomStatuses": "set-module-scss-module__NnuviW__dataroomStatuses",
  "dataroomTable": "set-module-scss-module__NnuviW__dataroomTable",
  "deactivatedDataroom": "set-module-scss-module__NnuviW__deactivatedDataroom",
  "denied": "set-module-scss-module__NnuviW__denied",
  "disabled": "set-module-scss-module__NnuviW__disabled",
  "errorMessage": "set-module-scss-module__NnuviW__errorMessage",
  "exploreSetsActions": "set-module-scss-module__NnuviW__exploreSetsActions",
  "follow": "set-module-scss-module__NnuviW__follow",
  "hideTooltipOnMobile": "set-module-scss-module__NnuviW__hideTooltipOnMobile",
  "iconWrapper": "set-module-scss-module__NnuviW__iconWrapper",
  "initialPreloaderWrp": "set-module-scss-module__NnuviW__initialPreloaderWrp",
  "isActionItemVisible": "set-module-scss-module__NnuviW__isActionItemVisible",
  "isEmpty": "set-module-scss-module__NnuviW__isEmpty",
  "isExpired": "set-module-scss-module__NnuviW__isExpired",
  "isPublished": "set-module-scss-module__NnuviW__isPublished",
  "isTabActive": "set-module-scss-module__NnuviW__isTabActive",
  "link": "set-module-scss-module__NnuviW__link",
  "mobileColName": "set-module-scss-module__NnuviW__mobileColName",
  "mobileColStatuses": "set-module-scss-module__NnuviW__mobileColStatuses",
  "mobileDataroomActions": "set-module-scss-module__NnuviW__mobileDataroomActions",
  "mobilePaginator": "set-module-scss-module__NnuviW__mobilePaginator",
  "pending": "set-module-scss-module__NnuviW__pending",
  "requestStatus": "set-module-scss-module__NnuviW__requestStatus",
  "searchBlock": "set-module-scss-module__NnuviW__searchBlock",
  "searchInput": "set-module-scss-module__NnuviW__searchInput",
  "searchInputFixedWidth": "set-module-scss-module__NnuviW__searchInputFixedWidth",
  "searchInputFormField": "set-module-scss-module__NnuviW__searchInputFormField",
  "sector": "set-module-scss-module__NnuviW__sector",
  "spanLink": "set-module-scss-module__NnuviW__spanLink",
  "specificWidth": "set-module-scss-module__NnuviW__specificWidth",
  "statusIndicator": "set-module-scss-module__NnuviW__statusIndicator",
  "tabs": "set-module-scss-module__NnuviW__tabs",
  "tabsLine": "set-module-scss-module__NnuviW__tabsLine",
  "tooltip": "set-module-scss-module__NnuviW__tooltip",
});
